import React, { useCallback, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { message } from 'antd';
import * as Sentry from '@sentry/react';
import { apis } from 'utils/lib/apis';

export interface PasswordRevealInlineProps {
    userId?: string | null;
    username?: string | null;
}

const PasswordRevealInline: React.FC<PasswordRevealInlineProps> = ({ userId, username }) => {
    const [plain, setPlain] = useState('');
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        if (!userId && !username) {
            message.warning('Missing user');
            return;
        }
        setLoading(true);
        try {
            const response = await apis.post('usersRDS', '/get_user_password', {
                body: { id: userId, username },
            });
            if (response?.success && response?.data?.password) {
                setPlain(String(response.data.password));
            } else {
                message.warning('No password stored');
            }
        } catch (error) {
            Sentry.captureException(error);
            message.error('Failed to load password');
        } finally {
            setLoading(false);
        }
    }, [userId, username]);

    if (plain) {
        return <span style={{ wordBreak: 'break-all' }}>{plain}</span>;
    }

    if (!userId && !username) {
        return <span>—</span>;
    }

    return (
        <Button
            size="small"
            variant="text"
            onClick={load}
            disabled={loading}
            sx={{ minWidth: 0, p: 0, textTransform: 'none' }}
        >
            {loading ? <CircularProgress size={14} /> : 'Show password'}
        </Button>
    );
};

export default PasswordRevealInline;
